(function () {
  var scheduled = false;

  function patchInstafeedButtons() {
    scheduled = false;
    document
      .querySelectorAll('[data-instafeed-role-button="true"]:not([role])')
      .forEach(function (el) {
        el.setAttribute('role', 'button');
      });
  }

  function schedulePatch() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(patchInstafeedButtons);
  }

  patchInstafeedButtons();
  new MutationObserver(schedulePatch).observe(document.body, { childList: true, subtree: true });
})();